/**
 * data/sampleTexts.ts - Sample text library for Transformr
 * 
 * CHANGE HISTORY:
 * - 251104_0831 [pending] danielbeer: Extracted sample texts to separate file
 */

export interface SampleText {
  id: string;
  name: string;
  format: string;
  content: string;
  description: string;
}

export const SAMPLE_TEXTS: SampleText[] = [
  {
    id: 'csv-contacts',
    name: 'CSV - Contacts',
    format: 'csv',
    content: `name,email,phone,company
John Doe,john@example.com,555-0100,Acme Corp
Jane Smith,jane@example.com,555-0101,Tech Inc
Bob Johnson,bob@example.com,555-0102,Data LLC`,
    description: 'Sample contact list in CSV format'
  },
  {
    id: 'json-users',
    name: 'JSON - Users',
    format: 'json',
    content: `[
  {
    "id": 1,
    "name": "John Doe",
    "email": "john@example.com",
    "role": "admin"
  },
  {
    "id": 2,
    "name": "Jane Smith",
    "email": "jane@example.com",
    "role": "user"
  }
]`,
    description: 'User data in JSON format'
  },
  {
    id: 'xml-products',
    name: 'XML - Products',
    format: 'xml',
    content: `<?xml version="1.0"?>
<products>
  <product id="1">
    <name>Widget</name>
    <price>19.99</price>
    <stock>100</stock>
  </product>
  <product id="2">
    <name>Gadget</name>
    <price>29.99</price>
    <stock>50</stock>
  </product>
</products>`,
    description: 'Product catalog in XML'
  },
  {
    id: 'vcard-contact',
    name: 'vCard - Contact',
    format: 'vcard',
    content: `BEGIN:VCARD
VERSION:3.0
FN:John Doe
N:Doe;John;;;
ORG:Acme Corp
TITLE:Developer
EMAIL:john@example.com
TEL:555-0100
ADR:;;123 Main St;Springfield;IL;62701;USA
END:VCARD`,
    description: 'Contact card in vCard format'
  },
  {
    id: 'email-signature-text',
    name: 'Email Signature - Text',
    format: 'text',
    content: `--
John Doe
Senior Developer
Acme Corporation
Email: john.doe@acme.com
Phone: +1 (555) 123-4567
Web: www.acme.com

This email and any attachments are confidential and may be privileged.`,
    description: 'Plain text email signature'
  },
  {
    id: 'email-signature-html',
    name: 'Email Signature - HTML',
    format: 'html',
    content: `<table cellpadding="0" cellspacing="0" style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
  <tr>
    <td style="padding-right: 20px; vertical-align: top;">
      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAADGklEQVR4nO2bS2sUQRSFv4kxGhVFRVFEfOADRRQVH7gQFBdufOBCcaEuXLhw4ULwD7hw40YQFy5cuHDhQkVBRRQfqBgfqNEYjZpEY+I1p6Gnp3q6Z3p6uqe7Zw4UDExX3Tq3bt2qW7cKYmJiYmJiYmJi/g+0A5PAW+AH8Nf+vgGTwBmgPWolewM3gd/AX0fZAm4ArVEp2gW8cHT8HzAN9Fu5AAwCM8Bvx/2ngc4wle0HvhQ6/h4YAFoc93YAV4Alhf2rgMEwlO0BPima/wAuAm0+2mkFLgNfFW0sAj1BK9sNfFQ0nwL6/LZlbU0oNj8C3UEqO6A4/hHQG0B7fYrND0Epe17RfDyo9qy9EcXu+SCUnVA0vx5ke9bmDcX2eL2VPaxo/irI9qzNq4rtw/VSdp+i+Ysg27M2LzqcsgX21UPZTkXzl0G2Z21eUmx31kPZdkXz10G2Z21eV2y311rZNkXzt0G2Z23eUmy31VrZVkXzd0G2Z23eVWy31FrZZkXz90G2Z20+UGw311rZJkXzD0G2Z20+Umw31VrZBkXzqSDbs/YeK7YbaqnsH0XzZ0G2Z+09U2z/qZWyPxTNXwTZnrX3UrH9o1bK/lQ0fxVke9bea8X2z1op+03R/E2Q7Vl7bxTb32ql7FdF83dBtmftvVNsf62Vsl8Uzd8H2Z619wGYU+x/qYWyc4rmH4Nsz9r7qNieq4Wys4rmn4Jsz9r7pNierYWyM4rmX4Jsz9r7qtieqYWy04rmS0G2Z+0tKbanayUs0K9ovhxke9besmJ7f6WEDfoUzVeCbM/aW1Fs91VK2KJH0Xw1yPasvVXFdk+lhE26Fc3XgmzP2ltTbHdVStikU9F8Pcj2rL11xXZnpYSNtima/wqyPWvvl2K7o1LCZm2K5htBtmftvVdst1VK2KxV0XwzyPasvU3FdmulhA1aFM23gmzP2tuybG8plrBJk6L5dpDtWXvbiu2mSgkb/FM03wmyPWtvR7H9r1LCJn8VzXeDbM/a21Vs/6mUsMkfRfO9INuz9vYU239iYmJiYmJiYmKIkr/tKDCJGKS6ZAAAAABJRU5ErkJggg==" alt="Logo" width="64" height="64" style="display: block;" />
    </td>
    <td style="border-left: 2px solid #667eea; padding-left: 20px;">
      <div style="font-size: 16px; font-weight: bold; color: #667eea; margin-bottom: 5px;">John Doe</div>
      <div style="font-size: 13px; color: #666; margin-bottom: 3px;">Senior Developer</div>
      <div style="font-size: 13px; color: #666; margin-bottom: 10px;">Acme Corporation</div>
      <div style="font-size: 12px; color: #888; line-height: 1.6;">
        <div>📧 john.doe@acme.com</div>
        <div>📞 +1 (555) 123-4567</div>
        <div>🌐 www.acme.com</div>
      </div>
    </td>
  </tr>
  <tr>
    <td colspan="2" style="padding-top: 15px; border-top: 1px solid #e0e0e0; margin-top: 15px;">
      <div style="font-size: 10px; color: #999; font-style: italic;">
        This email and any attachments are confidential and may be privileged.
      </div>
    </td>
  </tr>
</table>`,
    description: 'HTML email signature with logo'
  }
];
